module.exports={
    "over_size_message":"A imagem que você enviou tem mais de 10MB. Vamos compactar seu arquivo para upload. Por favor, clique em “Confirmar” para continuar o upload.",
    "file_type_error":"O arquivo que você enviou não é uma imagem! Por favor, tente fazer o upload novamente.",
    "upload_error":"Erro ao carregar! (Código de erro: 2000) Tente novamente.",
    "watermark_remove_over_size":"A imagem que você carregou tem mais de 5MB. É recomendável que você use nosso Compressor de Imagem Online Gratuito. Clique para <a class=\"jump-link\" href=\"https://www.tipard.com/pt/image-compressor-online/\">saiba mais</a>",
    "watermark_remove_file_type_error":"O arquivo que você enviou não é uma imagem, faça o upload novamente.",
    "watermark_remove_image_type_error":"O formato de imagem não é suportado. Suportamos apenas JPG, JPEG, PNG e BMP.",
    "watermark_remove_upload_error":"Erro de reconhecimento (código de erro: 2001), tente novamente...",
    "watermark_remove_processing":"Processando imagem...",
    "watermark_remove_not_save":"A área selecionada não será mantida. Tem certeza de que deseja cortá-lo?",
    "watermark_remove_back_home":"O status atual não será salvo. Tem certeza de que deseja voltar para casa?",
    "watermark_remove_new_image":"O status atual não será salvo. Tem certeza de que deseja escolher uma nova imagem?",
    "watermark_select":"Selecionar",
    "watermark_select_area":"Selecione a área da marca d'água que deseja apagar antes de clicar em Remover.",
    "watermark_beyond_4k":"A imagem selecionada excede a resolução de 4K. Lamentamos não poder processá-lo no momento",
    "watermark_beyond_pixel_1":"A resolução da imagem selecionada excede <span>%spx</span><span>&times;%spx</span>. Não pode ser processado, selecione novamente.",
    "watermark_beyond_pixel_2":"Os visitantes só podem processar imagens <span>%s</span> com resolução acima de <span>%spx</span>x<span>%spx</span>, faça o login e continue a usar.",
    "watermark_beyond_size_1":"O tamanho da imagem selecionada excede <span>%sMB</span>. Não pode ser processado, selecione novamente.",
    "watermark_beyond_size_2":"O tamanho da imagem selecionada excede <span>%sMB</span>, mas os visitantes só podem processar imagens com menos de <span>%sMB</span>. Por favor, faça o login e continue a usar.",
    "no_user_down":"Os visitantes só podem baixar imagens <span>%s</span> com qualidade original. Por favor, faça o login e continue o download. Além disso, você pode manter o histórico de 7 dias após o login. Continue baixando imagens com largura ou altura <span>%spx</span>.",
    "no_down_rights":"Não é possível baixar imagens HD com qualidade original, atualize seu plano! Você também pode continuar baixando imagens de baixa qualidade com <span>%spx</span>.",
    "error_40001":"Erro: 40001. Entre em contato conosco",
    "error_40099":"Erro: 40099. Entre em contato conosco",
    "down_btn":"O download está em preparação, aguarde um segundo...",
    "noRemove_down_btn":"Você não fez nada para remover marcas d'água. Selecione a marca d'água que deseja remover e clique no botão Remover. Então você pode baixar sua imagem.",
    "history_open":"Abrindo a imagem modificada, aguarde um momento...",
    "maskRightsMonitor_info":"A página de upgrade de benefícios foi aberta em uma nova guia e seu plano será sincronizado automaticamente após o upgrade.",
    "maskLoginMonitor_info":"A página de destino foi aberta, por favor, complete o login nela. Após o login ou registro com sucesso, esta página será sincronizada automaticamente, por favor, não a feche.",
    "photo_rights_info":"<span><i class=\"num\">2</i> imagens HD</span> com qualidade original podem ser baixadas no momento. <a href=\"https://account.tipard.com\" target=\"_blank\">Ver detalhes>></a>",
    "rights_original":"Para ativar a configuração \"Usar a função Image Enhancer para reduzir a perda de qualidade\", você precisa atualizar sua conta!",
    "Brush":"Escovar",
    "Lasso":"Laço",
    "Polygonal":"Poligonal",
    "Eraser":"Borracha",
    "Free":"Livre",
    "More":"Mais:",
    "Select":"Selecionar",
    "Remove":"Remover",
    "BrushSize":"Tamanho:",
    "AspectRatio":"Proporção da tela:",
    "Upload":"Nova foto",
    "History":"História",
    "Login":"Conecte-se",
    "MyAccount":"Minha conta",
    "Logout":"Sair",
    "Usinghelp":"Usando a ajuda>>",
    "Enhancer":"Use a função Image Enhancer para reduzir a perda de qualidade",
    "Download":"Download",
    "Guide":"Guia",
    "Polygonal1":"Poligonal",
    "Polygonal_info":"Clique com o botão esquerdo do mouse para identificar um ponto de cada vez.",
    "Lasso1":"Laço:",
    "Lasso_info":"Pressione e segure o botão esquerdo do mouse para laçar a área da marca d'água.",
    "Brush1":"Escovar:",
    "Brush_info":"Pressione e segure o botão esquerdo do mouse para selecionar com precisão.",
    "Eraser1":"Borracha:",
    "Eraser_info":"Apague as partes desnecessárias da área selecionada.",
    "Click":"Clique",
    "the":"a",
    "click_info":"botão para começar a apagar a marca d'água indesejada.",
    "PleaseUploadImages":"Por favor, carregue imagens.",
    "CropInfo":"Depois que a remoção da marca d'água estiver concluída, você pode clicar no botão Cortar para cortar sua imagem antes de salvar ou clicar no botão Baixar para salvar a imagem atual diretamente.",
    "Crop":"Colheita",
    "Back":"Costas",
    "DownloadCropped":"Baixar recortado",
    "Cancel":"Cancelar",
    "FreeWatermarkRemover":"Removedor de marca d'água grátis",
    "Processing":"Em processamento...",
    "NewImage":"Nova imagem",
    "Retry":"Repetir",
    "Yes":"Sim",
    "No":"Não",
    "FailureFeedback":"Feedback de falha",
    "removeTip":"Depois de selecionar a área da marca d'água, clique em Remover para apagar a marca d'água.",
    "rightDown":"Baixar imagens de baixa qualidade",
    "history_will":"Vai expirar após",
    "Expired":"(Expirado)",
	"uploadImage":"Adicionar imagem",
    "uploadImageInfo":"Ou solte seu arquivo de imagem aqui para remover a marca d'água!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Ilimitado",
    "watermark_beyond_pixel_3":"A imagem selecionada excede a <span>%s&times;%s resolução</span>, atualize seu plano primeiro.",
    "watermark_beyond_size_3":"A imagem selecionada excede <span>%sMB</span>, atualize seu plano primeiro.",
    "no_user_login":"Novos usuários que fizerem login podem obter DOIS benefícios de download de imagens originais em HD.<span class=\"loginMaskbtn\">Faça login imediatamente>></span>",
    "Upgrade":"Melhoria",
    "Loading":"Carregando…",
    "SelectAll":"Selecionar tudo",
    "Open":"Abrir",
    "Delete":"Excluir",
    "Clear":"Limpar inválido",
    "noHistory":"Sem histórico",
    "Close":"Perto",
    "buyUserInfo":"parabéns! Você atualizou com sucesso. Volte à página inicial e use este produto.",
    "buyNoUserInfo":"Parabéns! Você atualizou com sucesso. Os benefícios foram vinculados ao endereço de e-mail que você deixou durante a atualização. Por favor, use a conta cadastrada ou vinculada ao endereço de e-mail para <span class=\"loginMaskbtn\">login para usar os benefícios</span>. Se você não registrou ou vinculou uma conta com o endereço de e-mail, <span class=\"registerMaskbtn\">use o endereço de e-mail para registrar uma conta</span> ou vincule outras contas a este e- endereço de e-mail para usar os benefícios.",
    "GetStarted":"Iniciar",
    "AccessTo":"Acesso a:",
    "imagesOfwatermarkremoval":"imagens de remoção de marca d'água",
    "upTo":"Até",
    "perImage":"por imagem",
    "Support":"Apoio, suporte",
    "resolution":"resolução",
    "PrepaidPackage":"Pacote pré-pago",
    "PayasYouGo":"Pague conforme usar",
    "TaxIncl":"Imposto incl.",
    "Checkout":"Confira",
    "imagesDay":"imagens/dia",
    "imagesMonthly":"imagens/mensal",
    "image":"imagem",
    "images":"imagens",
    "imageSize":"tamanho da imagem",
    "buyInfo1":"Integrações de <span>enhancer</span> de terceiros",
    "buyInfo2":"O histórico de edição é válido por 7 dias",
    "buyInfo3":"Processamento prioritário",
    "buyInfo4":"Suporte ao cliente 7x24",
    "buyInfo5":"Expirado após 24 horas",
    "buyInfo6":"Sem assinatura. Sem renovação automática!",
    "buyInfo7":"Disponível para uso a qualquer momento para sempre",
    "dayPlan":"Plano de 1 dia",
    "Lifetime":"Vida",
    "note":"<span>Nota</span>: Observe que o plano adquirido está vinculado ao endereço de e-mail fornecido durante o checkout. Para usar o plano com sucesso, registre-se ou faça login com o mesmo endereço de e-mail.",
    "buy_now": "Comprar agora",
    
    "banner_title": "Limpeza de fotos da AI - quantos créditos você deseja",
    "banner_info": "1 crédito = 1 imagem: você custa 1 crédito para processar e salvar uma imagem maior que 600 × 600 pixels. ",
    "monthlyPlan_title": "Plano mensal",
    "monthlyPlan_displayPricePerCredit": "/crédito",
    "monthlyPlan_plan1_credits": "Créditos/MO",
    "monthlyPlan_feature1": "<rpa> livre de risco: </span> garantia de retorno do dinheiro de 30 dias",
    "monthlyPlan_feature2": "<span> Automático: </span> Os créditos são renovados automaticamente",
    "monthlyPlan_feature3": "<man> Flexível: </span> Downgrade, atualizar ou cancelar a qualquer momento",
    "oneTimePurchase_title": "Compra única",
    "oneTimePurchase_plan5_credits": "Créditos/Lifetime",
    "oneTimePurchase_feature1": "Garantia de devolução do dinheiro de 30 dias",
    "oneTimePurchase_feature2": "Permanentemente válido após a compra",
    "payment_title": "Você pode escolher vários métodos de pagamento",
    "payment_image_alt": "Métodos de pagamento",
    "faq_title": "Perguntas freqüentes sobre compra de créditos",
    "faq_question1_title": "O que são créditos?",
    "faq_question1_info": "Nosso serviço é medido na unidade de créditos. ",
    "faq_question2_title": "Devo escolher uma assinatura mensal ou uma compra única?",
    "faq_question2_info": "Para tarefas irregulares de imagem ou um requisito de uso pouco frequente, você pode escolher uma compra única, onde pode comprar a quantidade adequada de créditos com base nos requisitos de sua imagem. ",
    "faq_question3_title": "E se eu usar meus créditos?",
    "faq_question3_info": "Você pode atualizar sua assinatura ou continuar comprando um plano de compra único com base nas suas necessidades de processamento de fotos. ",
    "faq_question4_title": "Posso atualizar, fazer o downgrade ou cancelar minha assinatura?",
    "faq_question4_info": "Sim, você pode. ",
    "whyChoose_title": "Por que escolher o TIPARD",
    "whyChoose_reason1_title": "Download seguro",
    "whyChoose_reason1_info": "Os programas da Titard são 100% limpos e seguros",
    "whyChoose_reason2_title": "Tecnologia profissional",
    "whyChoose_reason2_info": "Equipe qualificada fornece produtos profissionais",
    "whyChoose_reason3_title": "Suporte ao cliente 24 horas por dia, 7 dias por semana",
    "whyChoose_reason3_info": "Serviços de consultores de pacientes o tempo todo",
    "whyChoose_reason4_title": "30 dias de volta",
    "whyChoose_reason4_info": "Garantir reembolso aos usuários em 30 dias",
    "whyChoose_reason5_title": "Mais de 1.000.000 de usuários",
    "whyChoose_reason5_info": "Usado e confiável por mais de 1 milhão de pessoas",
    "whyChoose_reason6_title": "Mais de 160 países",
    "whyChoose_reason6_info": "Vendido em mais de 160 países e regiões"
}